
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ImplantParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Implant {
  Id?: any;
    Name: string;
    TenantId?: string;
    BranchId?: string;
    parameters?: ImplantParameter[];
    links?: any;
}

export abstract class ImplantData {
 
  abstract list(url: string): Observable<Implant[]>;
  abstract create(url: string,data: Implant): Observable<any>;
  abstract update(url: string,data: Implant): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
